import { __decorate } from 'tslib';
import { Input, Directive, NgModule } from '@angular/core';
import { TuiController } from '@taiga-ui/cdk';

import * as ɵngcc0 from '@angular/core';
let TuiModeDirective = class TuiModeDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.mode = null;
    }
};
TuiModeDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiModeDirective_BaseFactory; return function TuiModeDirective_Factory(t) { return (ɵTuiModeDirective_BaseFactory || (ɵTuiModeDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiModeDirective)))(t || TuiModeDirective); }; }();
TuiModeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiModeDirective, selectors: [["", "tuiMode", ""]], inputs: { mode: ["tuiMode", "mode"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiMode')
], TuiModeDirective.prototype, "mode", void 0);

let TuiModeModule = class TuiModeModule {
};
TuiModeModule.ɵfac = function TuiModeModule_Factory(t) { return new (t || TuiModeModule)(); };
TuiModeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiModeModule });
TuiModeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiModeDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiMode]'
            }]
    }], null, { mode: [{
            type: Input,
            args: ['tuiMode']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiModeModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiModeDirective],
                exports: [TuiModeDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiModeModule, { declarations: [TuiModeDirective], exports: [TuiModeDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiModeDirective, TuiModeModule };

